module.exports = {
  'name': 'map',
  'category': 'Matrix',
  'syntax': [
    'map(x, callback)'
  ],
  'description': 'Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.',
  'examples': [
    'map([1, 2, 3], function(val) { return value * value })'
  ],
  'seealso': ['filter', 'forEach']
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/docs/function/matrix/map.js
// module id = 1020
// module chunks = 0